// Touch switch control — the standalone /device page (1 / 2 / 4 gang, any
// catalogue switch bank, and the 4+1 / 7+1 / 5+2 with their fan channels).
//
// Since 2026-10-03 this is the room card itself (components/DeviceControlCard
// TouchControlCard), shown larger: the PHONE's raised gradient buttons, All On /
// All Off bars, badges and fan channels, driven by core/hooks/useRelayStatus.
// It used to be a list of plain toggle switches with its own status parser — a
// third way of drawing the same device.

import React from 'react';
import { Box } from '@mui/material';
import DeviceShell from '../../components/DeviceShell';
import { TouchControlCard } from '../../components/DeviceControlCard';
import GlassPlateCard from '../../components/GlassPlateCard';
import { plateFor, PLATE_CARD_WIDTH } from '../../../../core/devices/glassPlates';

export default function TouchScreen({ device, gangs, fanChannels = 0 }) {
  const plate = plateFor(device.DeviceID);
  if (plate) {
    return (
      <DeviceShell title={device.DeviceName || device.UniqueNumber}>
        <Box sx={{ mt: 2, mx: 'auto', width: '100%', maxWidth: (PLATE_CARD_WIDTH[plate.modules] || 400) * 1.6 }}>
          <GlassPlateCard device={device} large />
        </Box>
      </DeviceShell>
    );
  }
  return (
    <DeviceShell title={device.DeviceName || device.UniqueNumber}>
      <Box sx={{ mt: 2, mx: 'auto', width: '100%', maxWidth: Math.max(360, Math.ceil(gangs / 2) * 130 + 40) }}>
        <TouchControlCard device={device} gangs={gangs} fanChannels={fanChannels} />
      </Box>
    </DeviceShell>
  );
}
